<template>
  <b-row class="px-3">
    <!-- Period -->
    <b-col md="12">
      <b-form-group
        label="Period"
        label-for="dateRange"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <date-picker
          style="width: 100%"
          v-model="localFilters.dateRange"
          type="date"
          range
          placeholder="Select date range"
        />
      </b-form-group>
    </b-col>

    <!-- Fleet Category -->
    <b-col md="12">
      <b-form-group
        label="Fleet Category"
        label-for="categoryId"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <v-multiselect
          v-model="localFilters.vehicleTypeIds"
          tag-placeholder="Fleets"
          placeholder="Search Fleets"
          label="name"
          track-by="code"
          :options="fleetCategoryOpt"
          :multiple="true"
          :taggable="true"
        />
      </b-form-group>
    </b-col>

    <!-- Fleet Name -->
    <b-col md="12">
      <b-form-group
        label="Fleet Name"
        label-for="vehicleIds"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <v-multiselect
          v-model="localFilters.vehicleIds"
          tag-placeholder="Fleets"
          placeholder="Search Fleets"
          label="name"
          track-by="code"
          :options="fleetNameOpt"
          :multiple="true"
          :taggable="true"
        />
      </b-form-group>
    </b-col>

    <!-- Status -->
    <b-col md="12">
      <b-form-group
        label="Status"
        label-for="status"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <b-form-select
          plain
          :options="statusList"
          v-model="localFilters.status"
        />
      </b-form-group>
    </b-col>

    <!-- Filter Options -->
    <b-col md="12">
      <b-form-group
        label="Filter Options"
        label-for="ownership"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <div class="d-flex">
          <b-form-radio
            v-model="localFilters.filterJobType"
            name="radio-a"
            class="mr-3"
            value="jobClass"
          >
            Job Class
          </b-form-radio>
          <b-form-radio
            v-model="localFilters.filterJobType"
            name="radio-b"
            value="jobType"
          >
            Job Type
          </b-form-radio>
        </div>
      </b-form-group>
    </b-col>

    <!-- Job Class / Job Type -->
    <b-col md="12" v-if="localFilters.filterJobType === 'jobClass'">
      <b-form-group
        label="Job Class"
        label-for="job-class"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <v-multiselect
          v-model="localFilters.jobClassIds"
          placeholder="Search job class"
          label="name"
          id="job-class"
          track-by="code"
          :options="jobClassList"
          :multiple="true"
          :taggable="true"
        />
      </b-form-group>
    </b-col>

    <b-col md="12" v-else>
      <b-form-group
        label="Job Type"
        label-for="job-type"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <v-multiselect
          v-model="localFilters.jobTypeIds"
          placeholder="Search job type"
          label="name"
          id="job-type"
          track-by="code"
          :options="jobTypeList"
          :multiple="true"
          :taggable="true"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'FilterMaintenance',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    fleetCategoryOpt: {
      type: Array,
      default: () => [],
    },
    fleetNameOpt: {
      type: Array,
      default: () => [],
    },
    statusList: {
      type: Array,
      default: () => [],
    },
    jobClassList: {
      type: Array,
      default: () => [],
    },
    jobTypeList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    localFilters: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>
